import { render } from "./InfoInstitucionalSection.vue?vue&type=template&id=966c037a"
import script from "./InfoInstitucionalSection.vue?vue&type=script&lang=js"
export * from "./InfoInstitucionalSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__